import redNotification from "./notifcation/redNotification.jpg";
import blueNotification from "./notifcation/blueNotification.jpg";
import react, { Component } from "react";
import domtoimage from "dom-to-image";
import { saveAs } from "file-saver";
import html2canvas from "html2canvas";

import "./notificationPhoto.css";

import React from "react";

const NotificationPhoto = ({ props }) => {
  const state = {
    appName: props.appName,
    courseName: `${props.courseName} Course`,
    coursePrice: `at just ₹ ${props.coursePrice}/-`,

    color: props.color,
    educatorPhoto: props.educatorPhoto,
  };

  const download = () => {
    // domtoimage
    //   .toBlob(document.getElementById("notification"), {
    //     quality: 5,
    //     // height: 512,
    //     // width: 942,
    //   })
    //   .then((blob) => {
    //     saveAs(blob, "poster.jpg");
    //   });

    var container = document.getElementById("notification"); //specific element on page
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

    // var container = document.getElementById("htmltoimage");; // full page
    html2canvas(container, { allowTaint: true }).then(function (canvas) {
      var link = document.createElement("a");
      document.body.appendChild(link);
      link.download = "Poster.png";
      link.href = canvas.toDataURL("image/png");
      link.target = "_blank";
      link.click();
    });
  };

  console.log(state.color);

  return (
    <div className="notificationContainer">
      <div
        className="notification"
        id="notification"
        style={
          state.color == "blue"
            ? { backgroundImage: `url(${blueNotification})` }
            : state.color == "red"
            ? { backgroundImage: `url(${redNotification})` }
            : state.color == ""
            ? { backgroundImage: `url(${redNotification})` }
            : ""
        }
      >
        <span id="appName-notification">{state.appName}</span>
        <div className="detailsDisplay-notification">
          <div className="left-notification">
            <img src={state.educatorPhoto} id="educatorPhoto-notification" />
            <span id="hashtag-notification">#PadhaiNahiRukegi</span>
          </div>
          <div className="right-notification">
            <span id="launching-notification">Launching</span>
            <span id="courseName-notification">
              {state.courseName}
              <br />
            </span>
            <span id="coursePrice-notification">{state.coursePrice}</span>
            <span id="buyNowCta-notification">Buy Now</span>
          </div>
        </div>
      </div>
      <button id="bannerCta-notification" onClick={download}>
        Click To Download
      </button>
    </div>
  );
};

export default NotificationPhoto;
